// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch_style_switch__WutZy","selected":"switch_style_selected__1mKzK","unselected":"switch_style_unselected__2niVd"};